module.exports = __webpack_public_path__ + "img/tree.1a02b55.svg";